module.exports = __webpack_public_path__ + "components/panel/ski-bro/static/euro-e08a3b3616ada658bf964522b4a69988.jpg";